import React from "react"
// Styles, images
import * as styles from "./Styles/Sidebar.module.scss"
import "../../styles/layouts"
import logo from "../../images/logo_white.png"
import { AvailableMenu } from "./Menu"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import { MenuProps } from "./types"
import Support from "./Support"

const Sidebar: React.FC<MenuProps> = (props) => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.top}>
        <img src={logo} className={styles.logo} />
        <hr />
        <div>
          {AvailableMenu(props.availableMenus).map((m) => (
            <div className={styles.sidebarContentWrapper} key={m.key}>
              <a
                href={props.paths[m.key]}
                target={m.suffixIcon ? "_blank" : ""}
              >
                <div
                  className={cn("sidebarContent", "l-flex", {
                    selected: props.selected == m.key,
                  })}
                >
                  {m.icon(styles.sidebarIcon)}
                  <span>{m.title}</span>
                  {m.suffixIcon && m.suffixIcon(styles.suffixIcon)}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.bottom}>
        <hr />
        <Support />
      </div>
    </div>
  )
}
export default Sidebar
